import React, { Component } from "react";
import {
  Button,
  Card,
  Col,
  Row,
  Badge,
  Tab,
  Tabs,
  Modal,
  Form,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";
import { Link } from "react-router-dom";

export default class DeploymentDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      role: sessionStorage.getItem("role") || "",
      activeTab: "myRequests",
      myRequests: [],
      pendingApprovals: [],
      readyForDeployment: [],
      pendingAssignments: [],
      notifications: [],
      stats: {
        totalRequests: 0,
        pendingApproval: 0,
        readyDeploy: 0,
        deployed: 0,
      },
      myRequestColumns: [
        {
          name: "S.No",
          selector: (row) => row.deploymentrequests_Id,
          sortable: true,
        },
        {
          name: "Request Id",
          selector: (row) => row.requestCode,
          sortable: true,
        },
        {
          name: "Project",
          selector: (row) => row.projectName,
          sortable: true,
        },
        {
          name: "Type",
          selector: (row) => row.requestType,
          sortable: true,
          cell: (row) => (
            <Badge bg={row.requestType === "UI" ? "primary" : "success"}>
              {row.requestType || "N/A"}
            </Badge>
          ),
        },
        {
          name: "Environment",
          selector: (row) => row.targetEnvironment,
          sortable: true,
        },
        {
          name: "Stage",
          selector: (row) => row.currentStage,
          sortable: true,
          cell: (row) => (
            <Badge bg={this.getStageBadgeColor(row.currentStage)}>
              {row.currentStage || "Draft"}
            </Badge>
          ),
        },
        {
          name: "Pending At",
          selector: (row) => row.currentStage,
          sortable: true,
          cell: (row) => {
            const info = this.getPendingAtInfo(row);
            return (
              <span>
                <small className="text-muted">{info.label}:</small>{" "}
                <Badge
                  bg={info.label === "Deployed By" ? "success" : "warning"}
                >
                  {info.name}
                </Badge>
              </span>
            );
          },
        },
        {
          name: "Cross-Team",
          selector: (row) => row.hasCrossTeamDependency,
          cell: (row) => (
            <span>
              {row.hasCrossTeamDependency == 1 ? (
                <Badge bg="warning">Yes - {row.crossTeamStatus}</Badge>
              ) : (
                "No"
              )}
            </span>
          ),
        },
        {
          name: "Date",
          selector: (row) => row.requestDate,
          sortable: true,
          cell: (row) => <span>{window.formatDate(row.requestDate)}</span>,
        },
      ],
      approvalColumns: [
        {
          name: "S.No",
          selector: (row) => row.deploymentrequests_Id,
          sortable: true,
        },
        {
          name: "Request Code",
          selector: (row) => row.requestCode,
          sortable: true,
        },
        {
          name: "Project",
          selector: (row) => row.projectName,
          sortable: true,
        },
        {
          name: "Requested By",
          selector: (row) => row.requesterName,
          sortable: true,
          cell: (row) => <span>{row.requesterName || "-"}</span>,
        },
        {
          name: "Type",
          selector: (row) => row.requestType,
          sortable: true,
          cell: (row) => (
            <Badge bg={row.requestType === "UI" ? "primary" : "success"}>
              {row.requestType || "N/A"}
            </Badge>
          ),
        },
        {
          name: "Reason",
          selector: (row) => row.reasonForDeployment,
          sortable: true,
        },
        {
          name: "Stage",
          selector: (row) => row.currentStage,
          cell: (row) => (
            <Badge bg="info">{row.currentStage || "PendingApproval"}</Badge>
          ),
        },
        {
          name: "Pending At",
          selector: (row) => row.currentStage,
          sortable: true,
          cell: (row) => {
            const info = this.getPendingAtInfo(row);
            return <Badge bg="warning">{info.name}</Badge>;
          },
        },
        {
          name: "Requested Date",
          selector: (row) => row.requestDate,
          sortable: true,
          cell: (row) => <span>{window.formatDate(row.requestDate)}</span>,
        },
        {
          name: "Actions",
          cell: (row) => (
            <div>
              <Link to="/deploymentapprovals">
                <Button size="sm" variant="primary">
                  Review
                </Button>
              </Link>
            </div>
          ),
        },
      ],
      deployColumns: [
        {
          name: "S.No",
          selector: (row) => row.deploymentrequests_Id,
          sortable: true,
        },
        {
          name: "Request Code",
          selector: (row) => row.requestCode,
          sortable: true,
        },
        {
          name: "Project",
          selector: (row) => row.projectName,
          sortable: true,
        },
        {
          name: "Requested By",
          selector: (row) => row.requesterName,
          sortable: true,
          cell: (row) => <span>{row.requesterName || "-"}</span>,
        },
        {
          name: "Type",
          selector: (row) => row.requestType,
          cell: (row) => (
            <Badge bg={row.requestType === "UI" ? "primary" : "success"}>
              {row.requestType || "N/A"}
            </Badge>
          ),
        },
        {
          name: "Environment",
          selector: (row) => row.targetEnvironment,
          sortable: true,
        },
        {
          name: "Priority",
          selector: (row) => row.priority,
          sortable: true,
        },
        {
          name: "Pending At",
          selector: (row) => row.currentStage,
          sortable: true,
          cell: (row) => {
            const info = this.getPendingAtInfo(row);
            return <Badge bg="warning">{info.name}</Badge>;
          },
        },
        {
          name: "Requested Date",
          selector: (row) => row.requestDate,
          sortable: true,
          cell: (row) => <span>{window.formatDate(row.requestDate)}</span>,
        },
        {
          name: "Actions",
          cell: (row) => (
            <div>
              <Button
                size="sm"
                variant="outline-primary"
                className="me-1"
                onClick={() => this.handlePreviewRequest(row)}
              >
                <i className="bi bi-eye"></i> Preview
              </Button>
              <Button
                size="sm"
                variant="warning"
                onClick={() => this.handleDeployClick(row)}
              >
                Deploy
              </Button>
            </div>
          ),
          width: "220px",
        },
      ],
      // Deployed files tab
      deployedFiles: [],
      deployedFileColumns: [
        {
          name: "S.No",
          selector: (row, index) => index + 1,
          width: "70px",
        },
        {
          name: "Request Code",
          selector: (row) => row.requestCode,
          sortable: true,
          cell: (row) => <span>{row.requestCode || "-"}</span>,
        },
        {
          name: "Requested By",
          selector: (row) => row.requesterName,
          sortable: true,
          cell: (row) => (
            <span>{row.requesterName || row.requestedBy || "-"}</span>
          ),
        },
        {
          name: "Type",
          selector: (row) => row.requestType,
          sortable: true,
          cell: (row) => (
            <Badge bg={row.requestType === "UI" ? "primary" : "success"}>
              {row.requestType || "N/A"}
            </Badge>
          ),
        },
        {
          name: "Environment",
          selector: (row) => row.targetEnvironment,
          sortable: true,
          cell: (row) => <span>{row.targetEnvironment || "-"}</span>,
        },
        {
          name: "File Name",
          selector: (row) => row.fileName,
          wrap: true,
          cell: (row) => this.renderList(row.fileName),
        },
        {
          name: "File Path",
          selector: (row) => row.filePath,
          wrap: true,
          cell: (row) => this.renderList(row.filePath),
        },
        {
          name: "Version",
          selector: (row) => row.version,
          cell: (row) => <span>{row.version || "-"}</span>,
        },
        {
          name: "Status",
          selector: (row) => row.deploymentFilestatus,
          sortable: true,
          cell: (row) => (
            <Badge
              bg={
                row.deploymentFilestatus === "Done"
                  ? "success"
                  : row.deploymentFilestatus === "Moved"
                    ? "info"
                    : "secondary"
              }
            >
              {row.deploymentFilestatus || "-"}
            </Badge>
          ),
        },
        {
          name: "Deployment Date",
          selector: (row) => row.deploymentDate,
          sortable: true,
          cell: (row) => <span>{this.formatDate(row.deploymentDate)}</span>,
        },
      ],
      // Preview modal
      showPreviewModal: false,
      previewRequest: null,
      previewFiles: [],
      previewPackages: [],
      // Deploy modal
      showDeployModal: false,
      deployRequest: null,
      deployStage: "Deploying",
      deployRemarks: "",
    };
  }
  // Format a yyyy-mm-dd (optionally with time) value to dd/mm/yyyy
  formatDate = (dateString) => {
    if (!dateString || dateString === "-") return "-";
    const datePart = String(dateString).split(/[ T]/)[0];
    if (datePart.includes("-")) {
      const [year, month, day] = datePart.split("-");
      if (year && month && day) return `${day}/${month}/${year}`;
    }
    return dateString;
  };

  // Format a "yyyy-mm-dd HH:mm:ss" value to "dd-mm-yyyy HH:mm:ss"
  formatDateTime = (value) => {
    if (!value || value === "-") return "-";
    const [datePart, timePart = ""] = String(value).split(/[ T]/);
    let out = datePart;
    if (datePart.includes("-")) {
      const [year, month, day] = datePart.split("-");
      if (year && month && day) out = `${day}-${month}-${year}`;
    }
    return timePart ? `${out} ${timePart.slice(0, 8)}` : out;
  };

  // Render a comma-separated string as a point-wise (bulleted) list
  renderList = (value) => {
    if (!value) return "-";
    const items = String(value)
      .split(",")
      .map((v) => v.trim())
      .filter(Boolean);
    if (items.length === 0) return "-";
    return (
      <ul className="mb-0 ps-3">
        {items.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    );
  };
  getStageBadgeColor = (stage) => {
    const colors = {
      Draft: "secondary",
      CrossTeamCheck: "info",
      WaitingForLinkedDev: "warning",
      PendingApproval: "info",
      Approved: "primary",
      Rejected: "danger",
      ReadyForDeployment: "success",
      Deploying: "warning",
      Deployed: "success",
      Failed: "danger",
      RolledBack: "dark",
    };
    return colors[stage] || "secondary";
  };

  getPendingAtInfo = (row) => {
    const stage = row.currentStage;
    if (stage === "PendingTLApproval")
      return { label: "Pending At", name: row.teamLeadName || "-" };
    if (stage === "PendingManagerApproval")
      return { label: "Pending At", name: row.managerName || "-" };
    if (stage === "ReadyForDeployment" || stage === "Deploying")
      return { label: "Pending At", name: row.assigneeName || "-" };
    if (stage === "Deployed")
      return { label: "Deployed By", name: row.deployedByName || "-" };
    return { label: "Pending At", name: "-" };
  };

  componentDidMount() {
    this.fetchMyRequests();
    this.fetchPendingApprovals();
    this.fetchReadyForDeployment();
    this.fetchPendingAssignments();
    this.fetchDeployedFiles();
  }

  fetchDeployedFiles = () => {
    const filesForm = new FormData();
    filesForm.append("sId", this.state.sId);

    const empForm = new FormData();
    empForm.append("sId", this.state.sId);
    empForm.append("uId", this.state.uId);

    Promise.all([
      // All deployment files
      fetch(configData.api_url + "C_Deploymentfiles/list", {
        method: "POST",
        body: filesForm,
      }).then((r) => r.json()),
      // All requests (to map file -> request -> requestedBy)
      fetch(configData.api_url + "C_Deploymentrequests/list", {
        method: "GET",
      }).then((r) => r.json()),
      // Employees (to find my reportees via rmId)
      fetch(configData.api_url + "C_Employees/list", {
        method: "POST",
        body: empForm,
      }).then((r) => r.json()),
    ])
      .then(([filesRes, requestsRes, empRes]) => {
        const files = filesRes.status === "success" ? filesRes.list || [] : [];
        const requests =
          requestsRes.status === "success" ? requestsRes.list || [] : [];
        const employees = empRes.status === "success" ? empRes.list || [] : [];

        const myId = String(this.state.uId);

        // Me + everyone who reports to me (direct reportees)
        const allowedUserIds = new Set([myId]);
        employees.forEach((e) => {
          if (String(e.rmId) === myId) {
            allowedUserIds.add(String(e.employees_Id));
          }
        });

        // Requests in the "Deployed" stage AND owned by me / my reportees
        // (latest-first)
        const deployedRequests = this.sortLatestFirst(
          requests.filter(
            (r) =>
              r.currentStage === "Deployed" &&
              allowedUserIds.has(String(r.requestedBy)),
          ),
        );

        // Build the rows: one row per file, plus a placeholder row for
        // deployed requests that have no files attached.
        const deployedFiles = [];
        deployedRequests.forEach((req) => {
          const reqId = String(req.deploymentrequests_Id);
          const reqFiles = files.filter(
            (f) => String(f.deploymentRequest_Id) === reqId,
          );
          if (reqFiles.length > 0) {
            reqFiles.forEach((f) => {
              deployedFiles.push({
                ...f,
                requestCode: req.requestCode,
                deploymentDate: req.deploymentDate,
                targetEnvironment: req.targetEnvironment,
                requestType: req.requestType,
                requesterName: req.requesterName,
                requestedBy: req.requestedBy,
              });
            });
          } else {
            // Deployed request with no files – still show it
            deployedFiles.push({
              deploymentRequest_Id: reqId,
              requestCode: req.requestCode,
              fileName: "",
              filePath: "",
              version: "",
              deploymentFilestatus: "Deployed",
              deploymentDate: req.deploymentDate,
              targetEnvironment: req.targetEnvironment,
              requestType: req.requestType,
              requesterName: req.requesterName,
              requestedBy: req.requestedBy,
            });
          }
        });

        this.setState({ deployedFiles });
      })
      .catch((error) => console.error("Error:", error));
  };

  // Sort a list of requests latest-first (highest id first)
  sortLatestFirst = (list) =>
    [...(list || [])].sort(
      (a, b) =>
        Number(b.deploymentrequests_Id || 0) -
        Number(a.deploymentrequests_Id || 0),
    );

  fetchMyRequests = () => {
    fetch(configData.api_url + "C_Deploymentrequests/list", {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const myData = this.sortLatestFirst(
            data.list.filter((r) => r.requestedBy == this.state.uId),
          );
          this.setState((prevState) => ({
            myRequests: myData,
            stats: {
              ...prevState.stats,
              totalRequests: myData.length,
              deployed: data.list.filter((r) => r.currentStage === "Deployed")
                .length,
            },
          }));
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  fetchPendingApprovals = () => {
    const frmdata = new FormData();
    frmdata.append("sId", this.state.sId);
    fetch(configData.api_url + "C_Deploymentrequests/listForApproval", {
      method: "POST",
      body: frmdata,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState((prevState) => ({
            pendingApprovals: this.sortLatestFirst(data.list),
            stats: {
              ...prevState.stats,
              pendingApproval: data.list.length,
            },
          }));
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  fetchReadyForDeployment = () => {
    fetch(configData.api_url + "C_Deploymentrequests/listForDeployment", {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState((prevState) => ({
            readyForDeployment: this.sortLatestFirst(data.list),
            stats: { ...prevState.stats, readyDeploy: data.list.length },
          }));
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  fetchPendingAssignments = () => {
    const frmdata = new FormData();
    frmdata.append("sId", this.state.sId);
    fetch(configData.api_url + "C_Deploymentlinkedrequests/pending", {
      method: "POST",
      body: frmdata,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ pendingAssignments: data.list });
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  handlePreviewRequest = (row) => {
    const requestId = row.deploymentrequests_Id;
    this.setState({
      showPreviewModal: true,
      previewRequest: row,
      previewFiles: [],
      previewPackages: [],
    });

    // Fetch files for this request
    const frmFiles = new FormData();
    frmFiles.append("sId", this.state.sId);
    fetch(configData.api_url + "C_Deploymentfiles/list", {
      method: "POST",
      body: frmFiles,
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status === "success") {
          const files = (data.list || []).filter(
            (f) => String(f.deploymentRequest_Id) === String(requestId),
          );
          this.setState({ previewFiles: files });
        }
      })
      .catch((e) => console.error(e));

    // Fetch packages for this request
    const frmPkg = new FormData();
    frmPkg.append("sId", this.state.sId);
    fetch(configData.api_url + "C_Deploymentpackages/list", {
      method: "POST",
      body: frmPkg,
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status === "success") {
          const pkgs = (data.list || []).filter(
            (p) => String(p.deploymentRequest_Id) === String(requestId),
          );
          this.setState({ previewPackages: pkgs });
        }
      })
      .catch((e) => console.error(e));
  };

  handleDeployClick = (row) => {
    this.setState({
      showDeployModal: true,
      deployRequest: row,
      deployStage: "Deploying",
      deployRemarks: "",
    });
  };

  handleDeploySubmit = () => {
    const { deployRequest, deployStage, deployRemarks } = this.state;
    if (!deployRequest) return;

    const frmdata = new FormData();
    frmdata.append("sId", this.state.sId);
    frmdata.append(
      "deploymentrequests_Id",
      deployRequest.deploymentrequests_Id,
    );
    frmdata.append("currentStage", deployStage);
    frmdata.append("deploymentStatus", deployStage);
    if (deployRemarks) frmdata.append("remarks", deployRemarks);

    fetch(configData.api_url + "C_Deploymentrequests/deployUpdate", {
      method: "POST",
      body: frmdata,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          toast.success(data.message);
          this.setState({ showDeployModal: false });
          this.fetchReadyForDeployment();
          this.fetchMyRequests();
        } else {
          toast.error(data.message);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error("Failed to update deployment status");
      });
  };

  render() {
    const {
      stats,
      myRequests,
      pendingApprovals,
      readyForDeployment,
      pendingAssignments,
      deployedFiles,
    } = this.state;
    return (
      <div className="container-fluid p-3">
        <h4>Deployment Dashboard</h4>

        {/* Stats Cards */}
        <Row className="mb-4">
          <Col md={3}>
            <Card className="text-center">
              <Card.Body>
                <Card.Title>{stats.totalRequests}</Card.Title>
                <Card.Text>My Requests</Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="text-center bg-info text-white">
              <Card.Body>
                <Card.Title>{stats.pendingApproval}</Card.Title>
                <Card.Text>Pending Approvals</Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="text-center bg-warning">
              <Card.Body>
                <Card.Title>{stats.readyDeploy}</Card.Title>
                <Card.Text>Ready to Deploy</Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="text-center bg-success text-white">
              <Card.Body>
                <Card.Title>{stats.deployed}</Card.Title>
                <Card.Text>Deployed</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Cross-team assignments alert */}
        {pendingAssignments.length > 0 && (
          <div className="alert alert-warning mb-3">
            <strong>Cross-Team Assignments:</strong> You have{" "}
            {pendingAssignments.length} pending cross-team request(s) assigned
            to you.
            <Link to="/linkedrequests" className="ms-2">
              <Button size="sm" variant="outline-warning">
                View Assignments
              </Button>
            </Link>
          </div>
        )}

        {/* Tabs */}
        <Tabs
          activeKey={this.state.activeTab}
          onSelect={(k) => this.setState({ activeTab: k })}
          className="mb-3"
        >
          <Tab
            eventKey="myRequests"
            title={`My Requests (${myRequests.length})`}
          >
            <DataTable
              columns={this.state.myRequestColumns}
              data={myRequests}
              pagination
              highlightOnHover
              striped
              paginationPerPage={100}
              keyField="id"
              paginationRowsPerPageOptions={[
                100, 200, 300, 400, 500, 600, 700, 800, 900, 1000,
              ]}
            />
          </Tab>
          <Tab
            eventKey="approvals"
            title={`Pending Approvals (${pendingApprovals.length})`}
          >
            <DataTable
              columns={this.state.approvalColumns}
              data={pendingApprovals}
              pagination
              highlightOnHover
              striped
            />
          </Tab>
          <Tab
            eventKey="deploy"
            title={`Ready to Deploy (${readyForDeployment.length})`}
          >
            <DataTable
              columns={this.state.deployColumns}
              data={readyForDeployment}
              pagination
              highlightOnHover
              striped
            />
          </Tab>
          <Tab
            eventKey="deployedFiles"
            title={`Deployed Files (${deployedFiles.length})`}
          >
            <DataTable
              columns={this.state.deployedFileColumns}
              data={deployedFiles}
              pagination
              highlightOnHover
              striped
              noDataComponent="No deployed files"
            />
          </Tab>
        </Tabs>

        {/* Preview Modal */}
        <Modal
          show={this.state.showPreviewModal}
          onHide={() => this.setState({ showPreviewModal: false })}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Deployment Request Preview</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.previewRequest && (
              <>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Request Code:</strong>{" "}
                    {this.state.previewRequest.requestCode}
                  </Col>
                  <Col md="6">
                    <strong>Project:</strong>{" "}
                    {this.state.previewRequest.projectName}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Type:</strong>{" "}
                    <Badge
                      bg={
                        this.state.previewRequest.requestType === "UI"
                          ? "primary"
                          : "success"
                      }
                    >
                      {this.state.previewRequest.requestType || "N/A"}
                    </Badge>
                  </Col>
                  <Col md="6">
                    <strong>Stage:</strong>{" "}
                    <Badge
                      bg={this.getStageBadgeColor(
                        this.state.previewRequest.currentStage,
                      )}
                    >
                      {this.state.previewRequest.currentStage || "N/A"}
                    </Badge>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Target Environment:</strong>{" "}
                    {this.state.previewRequest.targetEnvironment || "-"}
                  </Col>
                  <Col md="6">
                    <strong>Action Type:</strong>{" "}
                    {this.state.previewRequest.actionType || "-"}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Priority:</strong>{" "}
                    {this.state.previewRequest.priority || "-"}
                  </Col>
                  <Col md="6">
                    <strong>Request Date:</strong>{" "}
                    {this.formatDate(
                      this.state.previewRequest.requestDate || "-",
                    )}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Deployment File Status:</strong>{" "}
                    {this.state.previewRequest.deploymentFilestatus || "-"}
                  </Col>
                  <Col md="6">
                    <strong>Deployment Date:</strong>{" "}
                    {this.formatDate(
                      this.state.previewRequest.deploymentDate || "-",
                    )}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Requested By:</strong>{" "}
                    {this.state.previewRequest.requesterName ||
                      this.state.previewRequest.requestedBy ||
                      "-"}
                  </Col>
                  <Col md="6">
                    <strong>Created Date:</strong>{" "}
                    {this.formatDateTime(this.state.previewRequest.createdOn)}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Reason for Deployment:</strong>
                    <br />
                    {this.state.previewRequest.reasonForDeployment || "-"}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Remarks:</strong>
                    <br />
                    {this.state.previewRequest.remarks || "-"}
                  </Col>
                  <Col md="6">
                    {(() => {
                      const info = this.getPendingAtInfo(
                        this.state.previewRequest,
                      );
                      return (
                        <>
                          <strong>{info.label}:</strong>{" "}
                          <Badge
                            bg={
                              info.label === "Deployed By"
                                ? "success"
                                : "warning"
                            }
                          >
                            {info.name}
                          </Badge>
                        </>
                      );
                    })()}
                  </Col>
                </Row>

                {/* Deployment Files */}
                <hr />
                <h6>Deployment Files</h6>
                {this.state.previewFiles.length > 0 ? (
                  <DataTable
                    columns={[
                      {
                        name: "File Name",
                        selector: (r) => r.fileName,
                        wrap: true,
                        cell: (r) => this.renderList(r.fileName),
                      },
                      {
                        name: "File Path",
                        selector: (r) => r.filePath,
                        wrap: true,
                        cell: (r) => this.renderList(r.filePath),
                      },
                      { name: "Version", selector: (r) => r.version },
                      {
                        name: "Status",
                        selector: (r) => r.deploymentFilestatus,
                        cell: (r) => (
                          <Badge
                            bg={
                              r.deploymentFilestatus === "Done"
                                ? "success"
                                : r.deploymentFilestatus === "Moved"
                                  ? "info"
                                  : "secondary"
                            }
                          >
                            {r.deploymentFilestatus || "-"}
                          </Badge>
                        ),
                      },
                    ]}
                    data={this.state.previewFiles}
                    noDataComponent="No files"
                    dense
                    striped
                  />
                ) : (
                  <p className="text-muted">No files attached</p>
                )}

                {/* Deployment Packages */}
                <hr />
                <h6>Deployment Packages</h6>
                {this.state.previewPackages.length > 0 ? (
                  <DataTable
                    columns={[
                      {
                        name: "Package Name",
                        selector: (r) => r.packageName,
                        wrap: true,
                      },
                      { name: "Version", selector: (r) => r.version },
                      { name: "Build #", selector: (r) => r.buildNumber },
                      { name: "Type", selector: (r) => r.packageType },
                    ]}
                    data={this.state.previewPackages}
                    noDataComponent="No packages"
                    dense
                    striped
                  />
                ) : (
                  <p className="text-muted">No packages attached</p>
                )}
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="warning"
              onClick={() => {
                this.setState({ showPreviewModal: false });
                this.handleDeployClick(this.state.previewRequest);
              }}
            >
              Deploy
            </Button>
            <Button
              variant="secondary"
              onClick={() => this.setState({ showPreviewModal: false })}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Deploy Update Modal */}
        <Modal
          show={this.state.showDeployModal}
          onHide={() => this.setState({ showDeployModal: false })}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Update Deployment Status
              {this.state.deployRequest && (
                <span className="text-muted" style={{ fontSize: "0.8rem" }}>
                  {" "}
                  - {this.state.deployRequest.requestCode}
                </span>
              )}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>
                <strong>Deployment Status</strong>
              </Form.Label>
              <Form.Select
                value={this.state.deployStage}
                onChange={(e) => this.setState({ deployStage: e.target.value })}
              >
                <option value="Deploying">Deploying</option>
                <option value="Deployed">Deployed</option>
                <option value="Failed">Failed</option>
                <option value="RolledBack">Rolled Back</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>
                <strong>Remarks</strong>
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={this.state.deployRemarks}
                onChange={(e) =>
                  this.setState({ deployRemarks: e.target.value })
                }
                placeholder="Enter deployment remarks..."
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.setState({ showDeployModal: false })}
            >
              Cancel
            </Button>
            <Button variant="warning" onClick={this.handleDeploySubmit}>
              Update Status
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
